import React, { createContext, useState, useContext, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const IvnoiceContext = createContext();

export const useInvoiceContext = () => useContext(IvnoiceContext);

const createDefaultPlaces = (goodsName, useNulls = true) => [
  {
    weight: useNulls ? null : 0,
    width: useNulls ? null : 0,
    height: useNulls ? null : 0,
    length: useNulls ? null : 0,
    goods: [{
      name: goodsName,
      weight: useNulls ? null : 0,
      count: 1,
      article: "",
      price: null,
      insurance: useNulls ? null : 0,
      vat: -1
    }]
  }
];

const createDefaultDelivery = () => ({
  sender: {
    fio: '',
    contract_face: '',
    phones: [{ number: '', additional: '' }]
  },
  recipient: {
    fio: '',
    contract_face: '',
    phones: [{ number: '', additional: '' }]
  },
});

export const getDefaultInvoiceData = (goodsName = 'ТНП') => ({
  user_info: {},
  user_type: 'sender',
  payment_on_receipt: false,
  vat: -1,
  places: createDefaultPlaces(goodsName, true),
  selected_mode: 2,
  delivery_date_from: new Date(),
  additions: {},
  delivery: createDefaultDelivery(),
});

export const getDefaultInvoiceDataWithZeros = (goodsName = 'ТНП') => ({
  user_info: {},
  user_type: 'sender',
  payment_on_receipt: false,
  vat: -1,
  places: createDefaultPlaces(goodsName, false),
  selected_mode: 2,
  delivery_date_from: new Date(),
  additions: {},
  delivery: createDefaultDelivery(),
});

export const defaultInvoiceData = getDefaultInvoiceData();
export const defaultInvoiceDataWithZeros = getDefaultInvoiceDataWithZeros();

export const IvnoiceContextProvider = ({ children }) => {
  const { t } = useTranslation('basic');
  const LOCAL_STORAGE_KEY = 'invoiceFormCache';
  const CACHE_TTL_MS = 60 * 60 * 1000;

  const loadCachedInvoice = () => {
    try {
      const cached = localStorage.getItem(LOCAL_STORAGE_KEY);
      if (cached) {
        const parsed = JSON.parse(cached);
        const createdAt = new Date(parsed.__cachedAt || 0).getTime();
        if (Date.now() - createdAt < CACHE_TTL_MS) {
          delete parsed.__cachedAt;
          return parsed;
        } else {
          localStorage.removeItem(LOCAL_STORAGE_KEY);
        }
      }
    } catch (err) {
      console.warn('Cache load error:', err);
    }
    return getDefaultInvoiceData(t('default_goods_name'));
  };

  const [invoiceData, setInvoiceData] = useState(() => getDefaultInvoiceData(t('default_goods_name')));

  // Сохраняем данные в localStorage при изменении состояния  
  useEffect(() => {
    const dataToCache = {
      ...invoiceData,
      __cachedAt: new Date().toISOString(),
    };
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(dataToCache));
    console.log(invoiceData)
  }, [invoiceData]);

  // Функция очистки кэша, вызывается после успешного сохранения накладной
  const clearInvoiceCache = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
    setInvoiceData(getDefaultInvoiceData(t('default_goods_name')));
  };

  const [cache, setCache] = useState({});
  const [templates, setTemplates] = useState([]);

  return (
    <IvnoiceContext.Provider value={{
      invoiceData, setInvoiceData,
      cache, setCache,
      clearInvoiceCache,
      templates, setTemplates,
    }}>
      {children}
    </IvnoiceContext.Provider>
  );
};
